import React from 'react';
import ReactDOM from 'react-dom/client';
import jsPDF from 'jspdf';
import { AppSettingsProvider } from '../utils/AppSettingsContext';
import NotificationPrintView from '../components/NotificationPrintView';

export const exportNotificationPdf = async (notification, approvedByName = '') => {
  if (!notification) return;
  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.left = '-10000px';
  container.style.top = '0';
  container.style.width = '794px';
  container.style.background = 'white';
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);
  root.render(
    <AppSettingsProvider>
      <NotificationPrintView notification={notification} approvedByName={approvedByName} isExportMode />
    </AppSettingsProvider>
  );

  await new Promise(resolve => setTimeout(resolve, 300));

  const doc = new jsPDF({ unit: 'pt', format: 'a4', orientation: 'portrait', autoPaging: 'text' });
  await doc.html(container.querySelector('#printable-notification'), {
    callback: d => {
      d.save(`notification_${notification.notificationNumber}.pdf`);
      root.unmount();
      container.remove();
    },
    x: 0,
    y: 80,
    margin: -65,
    autoPaging: 'text',
    html2canvas: {
      scale: 0.66,
      useCORS: true,
      width: 822,
      windowWidth: 822,
    },
  });
};

export default exportNotificationPdf;

